/* Accounts this device trusts for PIN sign-in, one list per login page ("" = /login). Only opaque device tokens + display info. */
const key = (scope) => `trusted_devices:${scope || "_platform"}`;

export const trustedAccounts = (scope) => { try { return JSON.parse(localStorage.getItem(key(scope))) || []; } catch (_) { return []; } };
const save = (scope, list) => localStorage.setItem(key(scope), JSON.stringify(list.slice(0, 10)));

/** Adds (or replaces, per email) the account returned with a device token. */
export const rememberDevice = (device) => {
  if (!device?.token) return;
  const list = trustedAccounts(device.scope).filter((a) => a.email !== device.email);
  save(device.scope, [{ token: device.token, name: device.name, email: device.email, masked: device.masked }, ...list]);
};
export const forgetDevice = (scope, token) => save(scope, trustedAccounts(scope).filter((a) => a.token !== token));
export const setTrusted = (scope, list) => save(scope, list);
export const initialsOf = (name) => (name || "?").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("");
